export default class settingsController{
  constructor(
    $settings,
    $scope
  ) {
    'ngInject';
    this.$scope = $scope;
    this.$settings = $settings;
    this.invoiceAccounts = [];
    this.invoiceAccount = null;
  }

  $onInit(){
    this.fetchAll();
  }

  fetchAll() {
    this.$settings.fetchAll()
      .then(data => this.invoiceAccounts = data);
  }

  $onSubmit( data, $event ){
    this.blurActive();
    this.invoiceAccount.account_id = parseInt(this.invoiceAccount.account_id, 10);
    if (this.invoiceAccount.uri) {
      this.$settings.update(this.invoiceAccount)
          .then(() => this.$scope.formAppSettings.$submitted = false)
          .then(() => this.invoiceAccount = null)
          .then(() => this.$scope.formAppSettings.$setUntouched());
    } else {
      this.$settings.post(this.invoiceAccount)
          .then(() => this.$scope.formAppSettings.$submitted = false)
          .then(data => this.fetchAll())
          .then(() => this.invoiceAccount = null)
          .then(() => this.$scope.formAppSettings.$setUntouched());
    }
  }

  blurActive() {
    let activeElement = document.activeElement;
    if (activeElement) {
      activeElement.blur();
    }
  }

  $onSelect() {
    this.blurActive();
    this.$scope.formAppSettings.$setUntouched();
  }

  $createNew() {
    this.isNew = true;
    this.invoiceAccount = {};
  }

  $onClose($event){
    $event.preventDefault();
    this.close({$value: 'cancel'});
  }

};


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/settings/settings.controller.js
 **/